import { RatePlanMerged } from "@/helpers/interfaces/RatePlanMerged.ts";
import { RateSellMode } from "@/helpers/types/types.ts";

export const findRatePlanIdPerOccupancy = (rp: RatePlanMerged, guests: number): string => {
  if (rp.rateSellMode === RateSellMode.PerRoom) return rp.id;

  if (guests > rp.rateGroup.guestCapacity) {
    if (rp.occupancy === rp.rateGroup.guestCapacity) {
      return rp.id;
    } else {
      return rp.childRatePlans?.find((crp) => crp.occupancy === rp.rateGroup.guestCapacity)!.id;
    }
  }

  if (rp.occupancy === guests) return rp.id;

  return rp.childRatePlans?.find((rp) => rp.occupancy === guests)!.id;
};
